import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { api } from '../api-client.config';

const deleteCode = async (id: number) => api.delete(`/codes/${id}`);

export const useDeleteCodeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCode,
    onSuccess: () => {
      toast.success('Code deleted successfully');

      queryClient.invalidateQueries({
        queryKey: ['codes'],
      });
    },
    onError: (error) => {
      Promise.reject(error);
    },
  });
};
